import api from "../api";

export async function GetRolesList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/role/role-list/`,
  });
}

export async function GetCompetencyCategoryList(vacancy_type_id, lang_id = "1") {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/competency-category-list/${vacancy_type_id}`,
  });
}

export async function CreateQuestionTypeData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/create-question-type/`,
  });
}

export async function GetQuestionTypeList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-type-list/`,
  });
}

export async function GetQuestionTypeRow(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-type-row/${id}`,
  });
}

export async function UpdateQuestionTypeData(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/update-question-type/${id}`,
  });
}

export async function DeleteRecords(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/delete-record/${id}`,
  });
}

export async function CreateQuestionParentData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/create-question-parent/`,
  });
}

export async function GetQuestionParentList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-parent-list`,
  });
}

export async function GetQuestionParentEdit(id, lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-parent-edit/${id}`,
  });
}

export async function UpdateQuestionParentData(data, id, lang_id = 1) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/update-question-parent/${id}`,
  });
}

export async function DeleteQuestionParentRecords(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/delete-question-parent-record/${id}`,
  });
}

export async function CreateQuestionBehaviourData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/create-question-behaviour/`,
  });
}

export async function GetQuestionBehaviourList() {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-behaviour-list/`,
  });
}

export async function GetQuestionBehaviourEdit(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-behaviour-edit/${id}`,
  });
}

export async function UpdateQuestionBehaviourData(data, id) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/update-question-behaviour/${id}`,
  });
}

export async function DeleteQuestionbehaviourRecords(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/delete-question-behaviour-record/${id}`,
  });
}

export async function CreateQuestionData(data, lang_id = 1) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/create-question/`,
  });
}

export async function GetQuestionsList(lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-list/`,
  });
}

export async function GetQuestionEdit(id, lang_id = 1) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/edit-question/${id}`,
  });
}

export async function UpdateQuestionData(data, id, lang_id = 1) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/update-question/${id}`,
  });
}

export async function DeleteQuestionRecord(id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/delete-question-record/${id}`,
  });
}

export async function GetQuestionParentDescription(ques_parent_id) {
  return await api({
    method: "get",
    url: `${process.env.REACT_APP_API_URL}/admin/question/question-parent-description/${ques_parent_id}`,
  });
}

export async function importQuestionsParsedData(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/question/bulk-upload-questions`,
  });
}
